<template>
    <v-row wrap class="ma-0">
        <v-col v-if="journalBis" cols="12"  class="my-2 text-caption">
            <p class=" d-flex justify-center my-0 py-0" >Last changed {{ journalBis.updated| dateEU('D MMM YYYY') }}. </p>
            <p class=" d-flex flex-wrap justify-center" >Please mail any comments to
            <a :href="['mailto:' + journalBis.email]" class="pl-1">{{ journalBis.email }}</a>
            </p>
        </v-col>
    </v-row>
</template>
<script>
import {mapGetters} from 'vuex';
export default {
       computed:{
        ...mapGetters('library',{
            journal:'journal',
            journalBis:'journalBis',
        })
    },
}
</script>
